{
  "commentForm": {
    "placeholder": "Einen Kommentar hinzufügen"
  },
  "commentList": {
    "title": "Alle Kommentare"
  },
  "viewAllComments": "Alle Kommentare ansehen",
  "edited": "Bearbeitet",
  "comment": "Kommentar",
  "comments": "Kommentare",
  "moveComments": "Kommentare hierher verschieben",
  "showComments": "Kommentare anzeigen",
  "hideComments": "Kommentare ausblenden",
  "justNow": "Gerade eben",
  "deleteConfirmation": {
    "title": "Kommentar löschen",
    "description": "Bist du sicher, dass du diesen Kommentar löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "addComment": "Kommentar hinzufügen",
  "cancelComment": "Hinzufügen eines Kommentars abbrechen"
}